import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _18UpRatingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"18_up_rating"}/>
}
